// Canvas text has no CSS `truncate` — a long fighter name drawn with fillText overflows
// unbounded (over neighbours, off the arena edge). fitText clips it to a pixel budget with
// an ellipsis. Call it AFTER ctx.font is set, since measureText depends on the active font.

const ELLIPSIS = '…';

/** The longest prefix of `text` (plus an ellipsis) whose rendered width fits `maxPx`.
 *  Returns `text` untouched when it already fits. Slices on code points, so emoji /
 *  surrogate pairs are never cut in half. */
export function fitText(ctx: { measureText(text: string): { width: number } }, text: string, maxPx: number): string {
  if (maxPx <= 0 || ctx.measureText(text).width <= maxPx) return text;
  const chars = Array.from(text); // code-point units, not UTF-16
  let lo = 0;
  let hi = chars.length;
  while (lo < hi) {
    const mid = (lo + hi + 1) >> 1;
    if (ctx.measureText(chars.slice(0, mid).join('') + ELLIPSIS).width <= maxPx) lo = mid;
    else hi = mid - 1;
  }
  return lo > 0 ? chars.slice(0, lo).join('') + ELLIPSIS : ELLIPSIS;
}
